export const storefrontRequestHeaders = {
  'Content-Type': 'application/graphql',
  'X-Shopify-Storefront-Access-Token': window.theme?.storefrontAPI?.key,
};

// Get the cart ID from the cookie
export const getCartId = () => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; cart=`);

  if (parts.length <= 1) {
    return '';
  }

  const cartId = `gid://shopify/Cart/${decodeURIComponent(parts.pop().split(';').shift())}`;

  return cartId;
};

// Get the cart data for applied discounts
export function cartQuery() {
  return `
    query {
      cart(id: "${getCartId()}") {
        cost {
          checkoutChargeAmount {
            amount
            currencyCode
          }
          subtotalAmount {
            amount
            currencyCode
          }
          totalAmount {
            amount
            currencyCode
          }
        }
        appliedGiftCards {
          amountUsed {
            amount
            currencyCode
          }
          balance {
            amount
            currencyCode
          }
          presentmentAmountUsed {
            amount
            currencyCode
          }
          id
          lastCharacters
        }
      }
    }
  `;
}

// Update the cart discount codes
export function cartDiscountCodesUpdate(discountCodes) {
  return `
    mutation {
      cartDiscountCodesUpdate(
        cartId: "${getCartId()}",
        discountCodes: ${JSON.stringify(discountCodes)}
      ) {
        cart {
          appliedGiftCards {
            id
            lastCharacters
          }
          discountCodes {
            code
            applicable
          }
        }
        userErrors {
          code
          field
          message
        }
      }
    }
  `;
}

// Update the cart gift card codes
export function cartGiftCardCodesUpdate(giftCardCodes) {
  return `
    mutation {
      cartGiftCardCodesUpdate(
        cartId: "${getCartId()}",
        giftCardCodes: ${JSON.stringify(giftCardCodes)}
      ) {
        cart {
          appliedGiftCards {
            id
            lastCharacters
          }
          discountCodes {
            code
            applicable
          }
        }
        userErrors {
          code
          field
          message
        }
      }
    }
  `;
}

export default storefrontRequestHeaders;
